import { render } from "./ViewRecord.vue?vue&type=template&id=e943ceba&scoped=true"
import script from "./ViewRecord.vue?vue&type=script&lang=js"
export * from "./ViewRecord.vue?vue&type=script&lang=js"

import "./ViewRecord.vue?vue&type=style&index=0&id=e943ceba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e943ceba"]])

export default __exports__